import clsx from 'clsx'
import find from 'lodash/find'
import map from 'lodash/map'
import React, { FC, useContext } from 'react'

import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

import styles from './LanguageToggle.module.scss'

interface LanguageToggleProps {
  showTitle?: boolean
}

export const LanguageToggle: FC<LanguageToggleProps> = ({ showTitle = true }) => {
  const { t } = useTranslation()
  const {
    alternateLinks,
    availableLocales,
    store,
  } = useContext(MetadataContext)

  if (!availableLocales || availableLocales.length < 2) {
    return null
  }

  return (
    <div className={styles.languageToggle}>
      <div className={styles.buttonsWrap}>
        {map(availableLocales, ({
          localeCode,
          title,
          url: localeURL,
        }) => {
          const url = new URL(find(alternateLinks, ['locale', localeCode])?.url || localeURL)

          return (
            <a
              key={title}
              aria-label={t('header:SIDE_BAR_LANG_SELECT_TITLE')}
              className={clsx(
                store?.config?.localeCode === localeCode && styles.isActive,
              )}
              href={url.pathname}
            >
              {title}
            </a>
          )
        })}
      </div>
      {showTitle && <span className={styles.toggleText}>{t('header:SIDE_BAR_LANG_SELECT_TITLE')}</span>}
    </div>
  )
}
